var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{pre:true,attrs:{"d":"M18 6 6 18"}}),_c('path',{pre:true,attrs:{"d":"m6 6 12 12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }